import React, { Component, Fragment } from 'react';
import { StatoDichiarazione, TipoDichiarazione } from 'enums';
import {
  Spinner,
  Formatter,
  OptionDropdown,
  ODataTable,
  PopOver,
  Highlighter,
} from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import { MiniPanel } from 'framework-ui-components/Components/V2';
import { cercaDichiarazioni } from 'apis/assegnoNucleoFamiliareApi';
import ModaleEsitiInps from './ModaleEsitiInps';
import Confirm from '../../components/Confirm';

String.prototype.capitalize = function () {
  return this.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
}

class RigaDichiarazione extends Component {
  constructor(props) {
    super(props);
    this.state = {
      working: false,
      duplicatoGiaPresente: false,
      esitoInvioINPS: null,
      modaleTrasmissioneAdEpasa: false,
      modaleEliminaANF: false,
    };
  }

  componentWillReceiveProps({ item }) {
    this.aggiornaStato({ working: this.state.working && this.state.item == item });
  }

  dichiarazioneModificabile(dichiarazione) {
    const { additionalRowData: { servizioAttivo } } = this.props;
    return servizioAttivo && dichiarazione.Stato === StatoDichiarazione.InLavorazione;
  }

  chiudiModaleEsitiInps() {
    this.setState({ mostraEsitiInps: false });
  }

  dichiarazioneStampabile() {
    return (
      this.props.item.Stato == StatoDichiarazione.InLavorazione
      || this.props.item.Stato == StatoDichiarazione.Completa
      || this.props.item.Stato == StatoDichiarazione.TrasmessaEPASA
      || this.props.item.Stato == StatoDichiarazione.InviataINPS
      || this.props.item.Stato == StatoDichiarazione.AccoltaINPS
    );
  }

  dichiarazioneImpostabileInLavorazione() {
    return (
      this.props.item.Stato !== StatoDichiarazione.InLavorazione
      && this.props.item.Stato !== StatoDichiarazione.TrasmessaEPASA
      && this.props.item.Stato !== StatoDichiarazione.InviataINPS
      && this.props.item.Stato !== StatoDichiarazione.RifiutataINPS
      && this.props.item.Stato !== StatoDichiarazione.ReiezioneINPS
      && this.props.item.Stato !== StatoDichiarazione.ReiezioneINPS
      && this.props.item.Stato !== StatoDichiarazione.AccoltaINPS
    );
  }

  dichiarazioneImpostabileCompleta() {
    return (
      this.props.item.Stato !== StatoDichiarazione.Completa
      && !this.props.item.HaErrori
      && this.props.item.Stato !== StatoDichiarazione.TrasmessaEPASA
      && this.props.item.Stato !== StatoDichiarazione.ScartataEPASA
      && this.props.item.Stato !== StatoDichiarazione.InviataINPS
      && this.props.item.Stato !== StatoDichiarazione.RifiutataINPS
      && this.props.item.Stato !== StatoDichiarazione.ReiezioneINPS
      && this.props.item.Stato !== StatoDichiarazione.AccoltaINPS
    );
  }

  dichiarazioneInviabileAdEPASA() {
    return (
      this.props.item.Stato === StatoDichiarazione.Completa
      || this.props.item.Stato === StatoDichiarazione.Stampata
    );
  }

  dichiarazioneScaricabileAdEPASA() {
    return (
      this.props.item.Stato === StatoDichiarazione.Completa
      || this.props.item.Stato === StatoDichiarazione.InLavorazione
    );
  }

  dichiarazioneClonabile() {
    return this.props.item.Stato === StatoDichiarazione.ReiezioneINPS;
  }

  esitoInvioINPSVisualizzabile = () => (
    this.props.item.Stato == StatoDichiarazione.InviataINPS
    || this.props.item.Stato == StatoDichiarazione.RifiutataINPS
    || this.props.item.Stato == StatoDichiarazione.ReiezioneINPS
    || this.props.item.Stato == StatoDichiarazione.AccoltaINPS
  );

  variazioneCreabile() {
    return this.props.item.Tipo == TipoDichiarazione.Ordinaria;
  }

  impostaStatoInLavorazione() {
    this.props.additionalRowData.avviaImpostaStatoInLavorazione([this.props.item.IdDichiarazione]);
  }

  impostaStatoCompleta() {
    this.props.additionalRowData.avviaImpostaStatoCompleta([this.props.item.IdDichiarazione]);
  }

  apriModaleTrasmissioneAdEpasa() {
    this.setState({ modaleTrasmissioneAdEpasa: true });
  }

  confermaModaleTrasmissioneAdEpasa() {
    const { additionalRowData, item } = this.props;
    additionalRowData.avviaTrasmissioneEPASA([item.IdDichiarazione]);
    this.chiudiModaleTrasmissioneAdEpasa();
  }

  chiudiModaleTrasmissioneAdEpasa() {
    this.setState({ modaleTrasmissioneAdEpasa: false });
  }

  // Scaricamento delega da Epasa
  scaricaDelegaPatronato(dichiarante) {
    this.props.additionalRowData.ottieniDelegaPatronatoEPASA(
      [this.props.item.IdDichiarazione],
      dichiarante,
    );
  }

  // Eliminazione domanda ANF
  apriModaleEliminaANF() {
    this.setState({ modaleEliminaANF: true });
  }

  chiudiModaleEliminaANF() {
    this.setState({ modaleEliminaANF: false });
  }

  confermaModaleEliminaANF() {
    this.eliminaANF();
    this.chiudiModaleEliminaANF();
  }

  eliminaANF() {
    const { IdDichiarazione: idDichiarazione } = this.props.item;
    this.aggiornaStato({ working: true })
      .then(() => this.props.additionalRowData.eliminaDichiarazione(idDichiarazione))
      .catch(() => this.aggiornaStato({ working: false }));
  }

  // Duplicazione domanda AUU precedntemente reietta da INPS
  duplicaDomandaANF() {
    const {
      IdDichiarazione: idDichiarazione, CodiceFiscale, CodiceUfficio, Tipo,
    } = this.props.item;
    this.aggiornaStato({ working: true })
      .then(() => this.props.additionalRowData.duplicaDomandaANF(idDichiarazione, CodiceFiscale, CodiceUfficio, Tipo))
      .catch(() => this.aggiornaStato({ working: false }));
  }


  creaVariazione() {
    const {
      CodiceFiscale: codiceFiscale,
      Cognome: cognome,
      Nome: nome,      
    } = this.props.item;

    this.props.additionalRowData.avviaCreazioneDichiarazioneVariazione({
      codiceFiscale,
      cognome,
      nome,
    });
  }

  aggiornaStato(data = {}) {
    return new Promise(resolve => this.setState(data, () => resolve(data)));
  }

  apriDichiarazione() {
    this.props.additionalRowData.apriDichiarazione(
      this.props.item.IdDichiarazione,
      this.dichiarazioneModificabile(this.props.item),
    );
  }

  stampaDichiarazione() {
    this.props.additionalRowData.avviaStampa([this.props.item.IdDichiarazione]);
  }

  verificaStatoDichiarazioni() {
    if (this.dichiarazioneClonabile()) {
      const {
        CodiceUfficio, Anno, CodiceFiscale, Tipo,
      } = this.props.item;
      cercaDichiarazioni(CodiceUfficio, 0, CodiceFiscale, Anno)
        .then(({ Items }) => this.setState({ duplicatoGiaPresente: Items.some(x => x.Stato !== StatoDichiarazione.ReiezioneINPS && x.Anno == Anno && x.Tipo === Tipo) }))
        .catch(() => this.setState({ duplicatoGiaPresente: true }));
    }
  }

  render() {
    const {
      item,
      additionalRowData: { termine, servizioAttivo },
    } = this.props;
    const {
      duplicatoGiaPresente,
      mostraEsitiInps,
      modaleTrasmissioneAdEpasa,
      modaleEliminaANF,
    } = this.state;


    const annoCampagna = 2020;
    
    let iconaTrattore = null;
    if (
      item.DatiAddizionali
      && item.DatiAddizionali.DipendenteAgricolo
      && item.DatiAddizionali.DipendenteAgricolo == 'true'
    ) {
      iconaTrattore = (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="tractor"
          className="svg-inline--fa fa-tractor icon"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        >
          <path
            fill="currentColor"
            d="M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
          />
        </svg>
      );
    }

    return (
      <Fragment>
        <tr onClick={() => this.apriDichiarazione()}>
          <td onClick={evt => evt.stopPropagation()}>
            <ODataTable.SelectCheckBox {...this.props} />
          </td>
          <td>
            <Highlighter text={item.Dichiarante} value={termine} />
          </td>
          <td>
            <Highlighter text={item.CodiceFiscale} value={termine} />
          </td>
          <td>{item.DatiAddizionali && item.DatiAddizionali.Azienda}</td>
          <td>{StatoDichiarazione.stringify(item.Stato, item.HaErrori)}</td>
          <td>{TipoDichiarazione.stringify(item.Tipo)}</td>
          <td>{iconaTrattore}</td>
          <td>{item.DatiAddizionali && item.Anno}</td>
          <td>{item.DatiAddizionali && item.DatiAddizionali.DataInizio}</td>
          <td>{item.DatiAddizionali && item.DatiAddizionali.DataFine ? item.DatiAddizionali.DataFine : "30/06/"+(item.Anno + 1)}</td>
          <td className="text--center">
            {item.DatiAddizionali && item.DatiAddizionali.Stampata === 'True' && (
              <PopOver top content="Stampata">
                <SuccessoIcon className="icon-success" />
              </PopOver>
            )}
          </td>
          <td>
            <Formatter tipo="date" valore={item.DataUltimaModifica || item.DataCreazione} />
          </td>
          <td />
          <td onClick={evt => evt.stopPropagation()}>
            {this.state.working ? (
              <Spinner small />)
              : (
                <OptionDropdown onClick={() => this.verificaStatoDichiarazioni()}>
                  <OptionDropdown.Item onClick={() => this.apriDichiarazione()}>
                    {servizioAttivo && this.dichiarazioneModificabile(item) ? 'Modifica' : 'Visualizza'}
                  </OptionDropdown.Item>
                  {servizioAttivo && this.dichiarazioneStampabile(item) && (
                    <OptionDropdown.Item onClick={() => this.stampaDichiarazione()}>
                      Stampa
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.dichiarazioneImpostabileInLavorazione(item) && (
                    <OptionDropdown.Item onClick={() => this.impostaStatoInLavorazione()}>
                      Imposta come "In Lavorazione"
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.dichiarazioneImpostabileCompleta(item) && (
                    <OptionDropdown.Item onClick={() => this.impostaStatoCompleta()}>
                      Imposta come "Completa"
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.variazioneCreabile(item) && item.Anno == annoCampagna && (
                    <OptionDropdown.Item onClick={() => this.creaVariazione()}>
                      Crea variazione
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.dichiarazioneInviabileAdEPASA(item) && (
                    <OptionDropdown.Item onClick={() => this.apriModaleTrasmissioneAdEpasa()}>
                      Invia a Patronato EPASA
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.dichiarazioneScaricabileAdEPASA(item) && (
                    <OptionDropdown.Item
                      onClick={() => this.scaricaDelegaPatronato(item.Dichiarante)}
                    >
                      Scarica delega e liberatoria del Patronato EPASA
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.esitoInvioINPSVisualizzabile() && (
                    <OptionDropdown.Item
                      onClick={() => this.setState({ mostraEsitiInps: true })}
                    >
                      Visualizza esiti INPS
                    </OptionDropdown.Item>
                  )}

                  {servizioAttivo && this.dichiarazioneClonabile() && (
                    <OptionDropdown.Item
                      onClick={() => this.duplicaDomandaANF()}
                      disabled={duplicatoGiaPresente}
                      showInfo={duplicatoGiaPresente}
                      infoContent="Questa opzione è possibile solo se, per la stessa annualità, non ci sono altre dichiarazioni in stato diverso da 'Reiezione Inps'"
                    >
                      Duplica in un nuovo Anf
                    </OptionDropdown.Item>
                  )}
                  {servizioAttivo && this.dichiarazioneModificabile(item) && (
                    <OptionDropdown.Item onClick={() => this.apriModaleEliminaANF()}>
                      Elimina
                    </OptionDropdown.Item>
                  )}
                </OptionDropdown>
              )}
          </td>
        </tr>
        {
          mostraEsitiInps && (
            <ModaleEsitiInps
              dichiarante={item.Dichiarante}
              statoDichiarazione={StatoDichiarazione.stringify(item.Stato, item.HaErrori)}
              onClose={() => this.chiudiModaleEsitiInps()}
              idDichiarazione={item.IdDichiarazione}
            />
          )
        }

        <Confirm
          show={modaleTrasmissioneAdEpasa}
          title="Invio domanda assegno nucleo familiare"
          message={(
            <div>
              <div>
                Una volta confermato l’invio della domanda di assegno nucleo familiare al patronato EPASA, non potrai annullarlo. Vuoi procedere?
              </div>
              <div><br /></div>
              <div>
                <MiniPanel
                  message="Il servizio è a consumo, verifica le condizioni economiche"
                  type="info"
                  position="right"
                />
              </div>
            </div>
          )}
          primaryLabel="Non inviare"
          onPrimaryClick={() => this.chiudiModaleTrasmissioneAdEpasa()}
          secondaryLabel="Invia"
          onSecondaryClick={() => this.confermaModaleTrasmissioneAdEpasa()}
        />

        <Confirm
          show={modaleEliminaANF}
          title="Elimina domanda"
          message={(
            <div>
              Vuoi eliminare la domanda di {item.Dichiarante.capitalize()}?
            </div>
          )}
          primaryLabel="Non eliminare"
          onPrimaryClick={() => this.chiudiModaleEliminaANF()}
          secondaryLabel="Elimina"
          onSecondaryClick={() => this.confermaModaleEliminaANF()}
          dangerous
        />


      </Fragment>
    );
  }
}

export default RigaDichiarazione;
